module.exports = __webpack_public_path__ + "static/media/coverage_corner_image.2969d81d.svg";